export default "__VITE_ASSET__DrzT5z8Y__"